const STATUS_META = {
  draft: { label: "Concept", className: "bg-slate-100 text-slate-700 border-slate-200" },
  received: { label: "Ontvangen", className: "bg-blue-50 text-blue-700 border-blue-200" },
  matched: { label: "Gekoppeld", className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  within_tolerance: { label: "Binnen tolerantie", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  needs_review: { label: "Controleren", className: "bg-amber-50 text-amber-800 border-amber-200" },
  approved: { label: "Goedgekeurd", className: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  rejected: { label: "Afgewezen", className: "bg-rose-50 text-rose-700 border-rose-200" },
  processed: { label: "Verwerkt", className: "bg-slate-100 text-slate-700 border-slate-200" },
  cancelled: { label: "Geannuleerd", className: "bg-slate-100 text-slate-500 border-slate-200" },
};

export default function SupplierInvoiceControlStatusBadge({ status }) {
  const meta = STATUS_META[String(status || "").trim()] || {
    label: String(status || "-"),
    className: "bg-slate-100 text-slate-700 border-slate-200",
  };

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${meta.className}`}>
      {meta.label}
    </span>
  );
}
